import { Beneficiaries } from './beneficiaryInterfaces';
import { BENEFICIARY_CATEGORIES_KEYS } from './helperFunctions';

export const transformStringToBeneficiaries = (
  beneficiaries: Beneficiaries,
  value?: string,
): Beneficiaries => {
  if (!value) return beneficiaries;
  for (const key of BENEFICIARY_CATEGORIES_KEYS) {
    if (beneficiaries[key]?.categories.length) return beneficiaries;
  }
  try {
    const b = JSON.parse(value) as Beneficiaries;
    if (typeof b !== 'object') return beneficiaries;
    for (const key of BENEFICIARY_CATEGORIES_KEYS) {
      if (b[key]?.categories.length) {
        return b;
      }
    }
    return beneficiaries;
  } catch (e) {
    return beneficiaries;
  }
};
